import { useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import Autosuggest from "react-autosuggest";

import { IconButton, TextField, InputAdornment } from '@mui/material';
import { SearchOutlined } from '@mui/icons-material';

import { useAuth } from "../../common/context/clientContext";
import { axiosPost } from "../../common/services/axios/apiCalls"

export default function SearchBar({
    collapse = false,
    searchIcon = false,
    textField = true,
    placeholder = 'Ingrese búsqueda...',
    searchPageUri = null
}) {
    /** CONST */
    const navigate = useNavigate();
    const { token } = useAuth();

    const [show, setShow] = useState(!collapse);
    const [searchValue, setSearchValue] = useState("");
    const [options, setOptions] = useState([]);

    // Simplificación de la lógica del enlace
    const searchPage = searchPageUri ? "/" + searchPageUri : "#"

    /** AUTOSUGGEST */
    const handleInputKeyDown = (event) => {
        if (event.key === "Enter" && options.length > 0) {
            event.preventDefault();
            onSuggestionSelected(null, { suggestion: options[0] });
            setSearchValue(options[0].name);
        }
    };

    const onSuggestionsFetchRequested = async ({ value }) => {
        if (!value) {
            setOptions([]);
            return;
        }

        const axiosData = {
            identify: value
        };

        try {
            const response = await axiosPost("/public/product/search/identify", token, axiosData);
            if (response.status.code === 200) {
                setOptions(response.data);
            }
        } catch (error) {
            setOptions([]); // Limpiar sugerencias en caso de error
        }
    };

    const onSuggestionsClearRequested = () => {
        setOptions([]);
    };

    const getSuggestionValue = (suggestion) => {
        // Devuelve el valor que se mostrará en el input cuando se selecciona una sugerencia
        return suggestion.name;
    };

    const renderSuggestion = (suggestion, index) => {
        return (
            <div
                key={"key_" + index}
                value={suggestion}
            >
                {suggestion.name}
            </div>
        )
    }

    const onSuggestionSelected = (_, { suggestion }) => {
        // Redirigir a la página del producto
        navigate(`/product/${suggestion.code}`);
    };

    const renderInputComponent = (inputProps) => {
        const { key, ...rest } = inputProps;
        return (
            <TextField
                {...rest}
                key={key}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchOutlined />
                        </InputAdornment>
                    ),
                }}
                variant="outlined"
                fullWidth
                sx={{
                    '& input': {
                        border: 'none',
                        backgroundColor: '#FFFFFF',
                        borderRadius: '100px',
                    },
                    '& .MuiOutlinedInput-root': {
                        backgroundColor: '#FFFFFF',
                        borderRadius: '100px',
                    }
                }}
            />
        )
    };

    const autosuggestInputProps = {
        placeholder,
        className: `input-wrapper-fieldset ${show ? 'show' : ''}`,
        value: searchValue,
        onChange: (e, { newValue }) => setSearchValue(newValue),
        onKeyDown: handleInputKeyDown,
    };

    // Lógica para renderizar la barra de búsqueda completa
    if (textField) return (
        <div className='autosuggest-container'>
            <Autosuggest
                suggestions={options}
                onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                onSuggestionsClearRequested={onSuggestionsClearRequested}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={renderSuggestion}
                onSuggestionSelected={onSuggestionSelected}
                inputProps={autosuggestInputProps}
                renderInputComponent={renderInputComponent}
            />
            {/* Botón opcional */}
            {searchIcon &&
                <IconButton className='btn-navbar' onClick={() => { if (collapse) setShow(!show) }}>
                    <SearchOutlined sx={{ fontSize: 30 }} />
                </IconButton>
            }
        </div>
    );

    // Lógica para renderizar solo el icono de búsqueda como un enlace
    return (
        <Link to={searchPage} className='btn-navbar'>
            <SearchOutlined sx={{ fontSize: 30 }} />
        </Link>
    )

}